/**
 * User Profile Service
 * Manages user profile data with Firebase Firestore
 */

import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { auth, db } from './firebase';

export class UserProfileService {
  /**
   * Get user profile from Firestore
   * @param {string} userId - Optional user ID, uses current user if not provided
   * @returns {Promise<Object>} User profile object
   */
  static async getUserProfile(userId = null) {
    try {
      const user = userId || auth.currentUser?.uid;
      if (!user) {
        throw new Error('No authenticated user');
      }

      const userRef = doc(db, 'users', user);
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        return userDoc.data();
      } else {
        throw new Error('User profile not found');
      }
    } catch (error) {
      console.error('Error getting user profile:', error);
      throw error;
    }
  }

  /**
   * Update user phone number
   * @param {string} userId - User ID
   * @param {string} phone - Phone number in format xxx-xxx-xxxx
   * @returns {Promise<boolean>} Success status
   */
  static async updatePhone(userId, phone) {
    try {
      const user = userId || auth.currentUser?.uid;
      if (!user) {
        throw new Error('No authenticated user');
      }

      const userRef = doc(db, 'users', user);
      
      await updateDoc(userRef, {
        phone: phone,
        profileUpdatedAt: new Date()
      });

      return true;
    } catch (error) {
      console.error('Error updating phone:', error);
      throw error;
    }
  }
}

export default UserProfileService;
